import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { catchError, finalize, switchMap } from 'rxjs/operators';
import { AnalyticsFormService } from '../../../core/services/analytics-form.service';
import { AuthStoreService } from '../../../shared/services/auth/auth-store.service';
import { HandsetService } from '../../../core/services/handset.service';
import { customEmailValidator } from '../../../shared/validators/custom-email.validator';
import { throwError } from 'rxjs';
import { ISendEmailForm } from '../../../shared/interfaces/auth.interface';
import { LoaderButtonType } from '../../../shared/models/loader-button-type.enum';

@Component({
standalone: false,
  selector: 'app-send-email',
  styleUrls: ['./send-email.component.scss'],
  templateUrl: './send-email.component.html',
})
export class SendEmailComponent implements OnInit {
  @Input() public loginUrl: string;
  @Input() public verificationCodeUrl: string;
  @Input() public billtechPayMode: boolean;
  submitted = false;
  public email: FormControl<string> = new FormControl<string>('', [Validators.required, customEmailValidator]);
  public sendEmailForm: FormGroup = new FormGroup({
    email: this.email,
  });

  public loading: boolean;
  public errors: string[];
  private initialEmail: string;

  public formName = 'resetPassword';

  constructor(
    private authStore: AuthStoreService,
    private route: ActivatedRoute,
    private analyticsFormService: AnalyticsFormService,
    private router: Router,
    public handsetService: HandsetService,
  ) {
  }

  public ngOnInit(): void {
    this.initialEmail = this.route.snapshot.queryParamMap.get('email');
    this.email.setValue(this.initialEmail);
  }

  public onSendEmail(): void {
    if (this.sendEmailForm.valid) {
      this.loading = true;
      this.authStore
        .sendEmail(this.sendEmailForm.value)
        .pipe(
          catchError((errors) => {
            this.errors = errors;
            this.analyticsFormService.sendEventForCaughtError('email', this.formName);
            return throwError(() => errors);
          }),
          switchMap(() => {
            const p = this.route.snapshot.paramMap;
            const params = { email: this.email.value };
            p.keys.forEach((k) => (params[k] = p.get(k)));
            return this.router.navigate([this.verificationCodeUrl], {
              queryParams: {
                email: this.email.value,
              },
              queryParamsHandling: 'merge',
            });
          }),
          finalize(() => (this.loading = false)),
        )
        .subscribe();
    } else {
      this.submitted = true;
      this.analyticsFormService.sendEventForInvalidControls(this.sendEmailForm.controls, this.formName);
    }
  }

  public getQueryParams() {
    if (this.email.value) {
      return { email: this.email.value };
    } else if (this.initialEmail) {
      return { email: this.initialEmail };
    }
    return {};
  }

  protected readonly LoaderButtonType = LoaderButtonType;
}
